import {useParams} from 'react-router-dom'
import React, { useState } from 'react';

import {StoredcardContainerCom} from '../containers'
function StoredcardContainerComPage() {
    let { id,cardId } = useParams();
    let svparams = { 'id': id, cardId:cardId}
    return (
        <StoredcardContainerCom svparams= {svparams} />
    );
}
export default StoredcardContainerComPage